import AbstractDevice from '../all/AbstractDevice';
import STBKaonPlayerUtil from "./PlayerUtil";
import STBKaonConfig from "./config";
import AndroidId from "../android/Id";
import AndroidPlayer from "../android/Player";
import AbstractHTML5Player from '../all/AbstractHTML5Player';
import AndroidKeys from "../stbkaon/Keys";
import AndroidNetworkStatus from "../android/NetworkStatus";
import AndroidSystem from "../android/System";
import settings from '../all/settings';
import WorkstationKeys from '../workstation/Keys';
import logger from 'src/utils/logger/logger';

class STBKaonDevice extends AbstractDevice {
  constructor () {
    super(
      "android",
      new AndroidId(),
      settings.use_dexie ? new AbstractHTML5Player() : new AndroidPlayer(),
      new STBKaonPlayerUtil(),
      STBKaonConfig,
      settings.use_dexie? new WorkstationKeys() : new AndroidKeys(),
      new AndroidNetworkStatus(),
      new AndroidSystem(),
      "stbkaon"
    );
  }


  update_launcher(region, result){
    try {
      window.AndroidPlayerInterface.saveLauncher(region, JSON.stringify(result));
    }
    catch (e) {
      logger.error("[Device.update_launcher]", e);
    }
  }
}

export default STBKaonDevice;



// WEBPACK FOOTER //
// ./src/devices/stbkaon/Device.js